import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "19",
  r: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 3h4v12h-4z"
})), 'PriorityHighOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PriorityHighOutlined.js
// module id = 5618
// module chunks = 2